export default [{
    path: '/administracao/relatorios-modelos',
    component: () => import('@/views/Index'),
    children: [
      {
        name: 'Relatórios Modelos Histórico',
        path: 'historico',
        component: () => import('@/views/relatoriosModelos/Historico.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Relatórios Modelos' }
          ]
        }
      },
      {
        name: 'Relatórios Modelos Editar',
        path: 'edit/:id',
        component: () => import('@/views/relatoriosModelos/Edit.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Relatórios Modelos', path: '/administracao/relatorios-modelos/historico' },
            { name: 'Editar' }
          ]
        }
      },
      {
        name: 'Relatórios Modelos Adicionar',
        path: 'edit',
        component: () => import('@/views/relatoriosModelos/Edit.vue'),
        meta: {
          requiresAuth: true,
          admin: true,
          breadcrumb: [
            { name: 'Administração', path: '/administracao' },
            { name: 'Relatórios Modelos', path: '/administracao/relatorios-modelos/historico' },
            { name: 'Adicionar' }
          ]
        }
      }
    ]
  }]